<template>
    <site-img
        class="md-form layout1"
        :class="{'mg-bg': bgType === 'color'}"
        type="bgImg"
        :src="bgType === 'img' ? useBgSrc : ''"
        :style="{
            ...spaceStyle,
            ...colorStyle,
        }"
    >
        <div
            class="mask"
            v-if="showMask"
            :style="{
                background: maskColor
            }"
        ></div>
        <div class="md-form-outer f-col" :style="{ background: formBgColor }">
            <div class="md-form-container">
                <site-title
                    v-if="title"
                    :title="title"
                    align="left"
                />
                <div
                    class="md-form-content"
                    :class="{
                        right: layout === 'right'
                    }"
                >
                    <info-agent
                        :agent="agent"
                        styleType="v3"
                        :licenseName="licenseName"
                    />

                    <div class="info-right">
                        <info-form-v2
                            :registerRole="registerRole"
                            :tag="tag"
                            :questionnaire="questionnaire"
                            :onSubmitOption="onSubmitOption"
                            :formList="formList"
                            :showTitle="false"
                            :lenderStyle="lenderStyle"
                            :defaultMsg="defaultMsg"
                            :submitText="submitOptionText"
                            :submitStyle="{
                                backgroundColor: submitBgColor,
                            }"
                            :registerLogin="registerLogin"
                            :disclaimerColor="colorMap?.text || '#a0a3af'"
                            @done="handleShowToast"
                        />
                    </div>
                </div>

                <form-toast
                    v-model:visible="formToastVisible"
                    v-bind="formToastOption"
                    @confirm="handleToastConfirm"
                />
            </div>
        </div>
    </site-img>
</template>

<script>
import common from '../index';
import infoAgent from '../info-agent-v2.vue';
import infoFormV2 from '../info-form-v2.vue';
import formToast from '@/components/form-toast';

export default {
    mixins: [common],
    data: function() {
        return {};
    },
    components: {
        infoAgent,
        infoFormV2,
        formToast
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-form.layout1 {
    position: relative;
    .mask {
        position: absolute;
        left: 0px;
        top: 0px;
        right: 0px;
        bottom: 0px;
    }
    .md-form-outer {
        border: 1px solid var(--color-border);
        position: relative;
        z-index: 2;
        padding: 80px 170px;
        @include media-1680 {
            padding: 80px 120px;
        }
        @include media-1280 {
            padding: 80px 80px;
        }
        @include media-1080 {
            padding: 80px 40px;
        }
        @include media-800 {
            padding: 20px;
        }
    }
    .md-form-container {
        .site-title {
            margin-bottom: 22px;
        }
        .md-form-content {
            display: flex;
            &.right {
                flex-direction: row-reverse;
                .info-right {
                    padding-left: 0px;
                    padding-right: 50px;
                    @include media-800 {
                        padding: 10px 0px 0px;
                    }
                }
            }
            @include media-800 {
                display: block;
            }
        }
    }
    .info-agent {
        width: 375px;
        flex-shrink: 0;
        flex-grow: 0;
        position: relative;
        &:before {
            content: '';
            display: block;
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 42%;
            background: linear-gradient(
                180deg,
                rgba(25, 25, 25, 0) 0%,
                rgba(25, 25, 25, 0.7) 100%
            );
            pointer-events: none;
            z-index: 1;
        }
        .img-box {
            height: 100%;
        }
        .agent-detail {
            position: absolute;
            bottom: 20px;
            left: 0px;
            width: 100%;
            color: #fff;
            z-index: 2;
            padding-left: 20px;
            padding-right: 20px;
            .site-title {
                color: #fff;
                margin-bottom: 10px;
                text-align: left;
                font-size: 20px !important;
            }
            .position {
                font-size: 14px;
                font-family: var(--font-normal);
                opacity: 0.7;
            }
            .phone {
                font-size: 14px;
                font-family: var(--font-normal);
                margin-top: 6px;
            }
            @include media-800 {
                bottom: 22px;
            }
        }
        @include media-800 {
            width: 100%;
            height: 365px;
        }
    }
    .info-right {
        flex: 1;
        box-sizing: border-box;
        padding-left: 50px;
        .site-title {
            margin-bottom: 20px;
        }
        .basic-info {
            display: flex;
            flex-wrap: wrap;
            margin: -10px -10px 0px;
            .basic-info-input {
                width: calc(50% - 20px);
                flex-shrink: 0;
                flex-grow: 1;
                margin: 10px;
                &.question,
                &[class*='paragraphText'] {
                    width: calc(100% - 20px);
                    margin-bottom: 3px;

                    textarea {
                        box-shadow: none;
                        width: 100%;
                        height: 112px;
                        padding: 10px 15px;
                        background: transparent;
                        color: var(--g-text-color);
                        font-size: 16px;
                        &:focus {
                            border-color: var(--g-btn-background);
                        }
                    }
                    @include media-800 {
                        width: 100%;
                    }
                }
                @include media-800 {
                    width: 100%;
                    margin: 10px 0px;
                }
            }
            .chime-datepicker {
                input {
                    padding-left: 35px;
                    border-radius: 0;
                }
                .date-picker-input-wrapper i.iconfont {
                    top: 4px;
                }
            }
            @include media-800 {
                margin: 0px;
            }
        }
        .basic-info-input input,
        .basic-info-input .submit {
            width: 100%;
            height: 50px;
            box-shadow: none;
            padding: 0px 15px;
            background: transparent;
            color: var(--g-text-color);
        }
        .basic-info-input input {
            font-size: 16px;
            &:focus {
                border-color: var(--g-btn-background);
            }
        }
        .disclaimer-wrap.opt-in {
            margin-top: 0;
            color: var(--g-tip-color);
            .checkbox-li .check-box-container {
                border-color: var(--g-tip-color) !important;
            }
            .disclaimer-item,
            .disclaimer-content,
            .privacy-text {
                color: var(--g-tip-color);
            }
        }
        @include media-1080 {
            padding-left: 40px;
        }
        @include media-800 {
            width: 100%;
            padding: 10px 0px 0px;
        }
    }
    .info-form2 .submit-content input,
    .info-form2 .submit-content .submit {
        width: 100%;
        height: 50px;
        font-size: 20px;
    }

    .info-form2 .submit-content .submit-box {
        width: 100%;
        margin-top: 10px;
    }
    .v-input .input-container .label-top {
        color: var(--g-text-color);
        background: var(--g-bg-color);
        padding: 0 10px;
    }
}
</style>
